import { Languages, Check, Loader2, Sparkles } from 'lucide-react';
import { useI18n, AUTO_NOTE } from '@/lib/i18n';
import { toast } from '@/components/ui/sonner';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

export const LanguageSelector = ({ variant = 'light', className = '' }) => {
  const { lang, setLang, translating, LANGS } = useI18n();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  const tone = variant === 'dark'
    ? 'text-brand-cream/90 hover:text-brand-cream hover:bg-white/10'
    : 'text-muted-foreground hover:text-foreground hover:bg-accent';

  const choose = (code) => {
    if (code === lang) return;
    setLang(code);
    if (code !== 'es') toast(AUTO_NOTE[code] || AUTO_NOTE.en, { icon: null, duration: 3500 });
  };

  return (
    <div data-noi18n className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger
          data-testid="language-selector"
          aria-label="Seleccionar idioma / Select language"
          className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange/40 ${tone}`}
        >
          {translating ? <Loader2 className="h-4 w-4 animate-spin" /> : <Languages className="h-4 w-4" />}
          <span className="tabular-nums">{current.label}</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[190px]" data-testid="language-menu">
          <DropdownMenuLabel>Idioma · Language</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {LANGS.map((l) => (
            <DropdownMenuItem
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => choose(l.code)}
              className="flex items-center justify-between gap-3 cursor-pointer"
              dir={l.code === 'ar' ? 'rtl' : 'ltr'}
            >
              <span className="flex items-center gap-2"><span className="text-[10px] font-bold w-6 text-muted-foreground">{l.label}</span>{l.native}</span>
              {l.code === lang && <Check className="h-4 w-4 text-brand-orange" />}
            </DropdownMenuItem>
          ))}
          {lang !== 'es' && (
            <>
              <DropdownMenuSeparator />
              <p className="px-2 py-1.5 text-[11px] text-muted-foreground flex items-start gap-1.5" data-testid="lang-auto-note" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
                <Sparkles className="h-3 w-3 mt-0.5 shrink-0 text-brand-orange" /> {AUTO_NOTE[lang]}
              </p>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default LanguageSelector;
